// extracted by mini-css-extract-plugin
module.exports = {"Video":"videos_Video__egwQ8","Block":"videos_Block__Mvp6b","FullScreen":"videos_FullScreen__Hwye1","Close":"videos_Close__1Os40"};